import { AnySourceStream, Stream } from '../stream'
import { Pass } from './pass'

type DisposeFn = () => void

export class DoOnDisconnecting<V = any, E = any, C = any> extends Pass<V, E, C> {
    constructor(
        protected onDisconnecting: (stream: Stream<V, E, C>) => DisposeFn | void,
        source?: AnySourceStream<V, E, C>
    ) {
        super(source)
    }

    connect() {
        super.connect()
    }

    disconnect() {
        super.disconnect()
        this.onDisconnecting(this)
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        doOnDisconnecting<T>(
            onDisconnecting: (stream: Stream<DV, DE, DC>) => DisposeFn | void
        ): Stream<DV, DE, DC, DV, DE, DC>
    }
}

Stream.prototype.doOnDisconnecting = function <DV, DE, DC>(
    this: AnySourceStream<DV, DE, DC>,
    onDisconnecting: (stream: Stream<DV, DE, DC>) => DisposeFn | void
) {
    return new DoOnDisconnecting(onDisconnecting, this) // tslint:disable-line:no-invalid-this
}
